(() => {
  if (window.aleonaConversionReady) return;
  window.aleonaConversionReady = true;
  const root = () => window.Shopify?.routes?.root || '/';
  const isWelcomeApplied = cart => cart.discount_codes?.some(item => item.code.toUpperCase() === 'WELCOME15' && item.applicable)
    || cart.cart_level_discount_applications?.some(item => item.title.toUpperCase() === 'WELCOME15');
  let applying = false;

  function syncWelcome(cart) {
    document.querySelectorAll('[data-aleona-apply-welcome]').forEach(button => {
      const applied = isWelcomeApplied(cart);
      button.textContent = applied ? button.dataset.applied : button.dataset.idle;
      button.classList.toggle('is-applied', !!applied);
      button.setAttribute('aria-pressed', String(!!applied));
      if (applied) button.parentElement.querySelector('[data-aleona-welcome-status]').textContent = button.dataset.appliedNote;
    });
  }

  async function readCart() {
    const response = await fetch(root() + 'cart.js', { signal: AbortSignal.timeout(7000) });
    if (!response.ok) throw new Error('cart');
    return response.json();
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-aleona-apply-welcome]');
    if (!button || applying) return;
    applying = true;
    button.disabled = true;
    button.textContent = button.dataset.busy;
    const status = button.parentElement.querySelector('[data-aleona-welcome-status]');
    status.textContent = '';
    try {
      const cart = await readCart();
      if (isWelcomeApplied(cart)) {
        syncWelcome(cart);
        return;
      }
      const codes = [...new Set([...(cart.discount_codes || []).map(item => item.code), 'WELCOME15'])];
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
      const footerId = document.getElementById('main-cart-footer')?.dataset.id;
      const itemsId = document.getElementById('main-cart-items')?.dataset.id;
      if (footerId) sections.push(footerId);
      if (itemsId) sections.push(itemsId);
      const response = await fetch(root() + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal: AbortSignal.timeout(10000),
        body: JSON.stringify({ discount: codes.join(','), sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname })
      });
      if (!response.ok) throw new Error('discount');
      const updated = await response.json();
      if (!updated.item_count) {
        button.textContent = button.dataset.ready;
        status.textContent = button.dataset.readyNote;
        return;
      }
      if (!isWelcomeApplied(updated)) {
        button.textContent = button.dataset.idle;
        status.textContent = button.dataset.ineligible;
        return;
      }
      const focusWasInDrawer = drawer?.contains(button);
      if (updated.sections && drawer && updated.sections['cart-drawer']) {
        drawer.renderContents(updated, { open: drawer.classList.contains('active') });
      }
      if (updated.sections?.[footerId] && document.getElementById('main-cart-footer')) {
        const parsed = new DOMParser().parseFromString(updated.sections[footerId], 'text/html');
        const footer = parsed.getElementById('main-cart-footer');
        if (footer?.querySelector('[name=checkout]')) document.getElementById('main-cart-footer').innerHTML = footer.innerHTML;
      }
      if (updated.sections?.[itemsId] && document.querySelector('cart-items')) {
        const parsed = new DOMParser().parseFromString(updated.sections[itemsId], 'text/html');
        const items = parsed.querySelector('cart-items');
        if (items?.querySelector('form')) document.querySelector('cart-items').innerHTML = items.innerHTML;
      }
      syncWelcome(updated);
      if (focusWasInDrawer) drawer.querySelector('[data-aleona-apply-welcome], #CartDrawer-Checkout')?.focus({ preventScroll: true });
      window.dispatchEvent(new CustomEvent('aleona:welcome-applied', { detail: { cart: updated } }));
    } catch {
      button.textContent = button.dataset.idle;
      status.textContent = button.dataset.error;
    } finally {
      applying = false;
      button.disabled = false;
    }
  });

  window.addEventListener('aleona:cart-added', async event => {
    try { syncWelcome(event.detail?.cart || await readCart()); } catch { /* Keep checkout available. */ }
  });
  if (document.querySelector('[data-aleona-apply-welcome]')) readCart().then(syncWelcome).catch(() => {});

  class AleonaRestock extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        const form = event.currentTarget;
        if (!form.reportValidity() || form.dataset.pending === 'true') return;
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[data-restock-status]');
        form.dataset.pending = 'true';
        button.disabled = true;
        button.textContent = button.dataset.busy;
        status.textContent = '';
        try {
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
            method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-10-15' },
            signal: AbortSignal.timeout(12000),
            body: JSON.stringify({ data: {
              type: 'back-in-stock-subscription',
              attributes: { profile: { data: { type: 'profile', attributes: { email: form.elements.email.value.trim() } } }, channels: ['EMAIL'] },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.dataset.variant } } }
            } })
          });
          if (response.status !== 202) throw new Error('restock');
          status.textContent = form.dataset.success;
          form.reset();
          button.hidden = true;
        } catch {
          status.textContent = form.dataset.error;
        } finally {
          form.dataset.pending = 'false';
          button.disabled = false;
          button.textContent = button.dataset.idle;
        }
      });
    }
  }
  customElements.define('aleona-restock', AleonaRestock);

  function businessDays(date, count) {
    const result = new Date(date);
    while (count > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) count--;
    }
    return result;
  }
  function calendarDays(date, count) {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + count);
    while (result.getUTCDay() === 0 || result.getUTCDay() === 6) result.setUTCDate(result.getUTCDate() + 1);
    return result;
  }
  class AleonaDeliveryWindow extends HTMLElement {
    connectedCallback() {
      const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      const start = new Date(today + 'T12:00:00Z');
      const format = date => new Intl.DateTimeFormat(this.dataset.locale || 'en', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(date);
      const range = (min, max) => format(min) + ' – ' + format(max);
      const preorder = this.dataset.preorder === 'true';
      if (preorder) {
        const firstDispatch = calendarDays(start, 21);
        const lastDispatch = calendarDays(start, 28);
        this.querySelector('[data-dispatch-dates]').textContent = range(firstDispatch, lastDispatch);
        this.querySelector('[data-arrival-dates]').textContent = range(businessDays(firstDispatch, 2), businessDays(lastDispatch, 7));
      } else {
        this.querySelector('[data-arrival-dates]').textContent = range(businessDays(start, 2), businessDays(start, 9));
      }
    }
  }
  customElements.define('aleona-delivery-window', AleonaDeliveryWindow);
})();
